// extracted by mini-css-extract-plugin
module.exports = {"BerriesList":"Berries_BerriesList__2Mxze"};